import {
  SET_GUARDIAN_STATE,
  SET_GUARDIAN_HYDRATED,
  UNLOCK_GUARDIAN,
  SET_SELECTED_GUARDIAN,
  SET_GUARDIAN_PURCHASING,
  SET_GUARDIAN_ERROR,
  RESET_GUARDIANS,
} from './actionTypes';
import {
  GUARDIAN_NONE_ID,
  DEFAULT_UNLOCKED_GUARDIAN_IDS,
} from 'config/guardiansCatalog';

const initialState = {
  // Ids the user owns. Everything in DEFAULT_UNLOCKED_GUARDIAN_IDS is free.
  unlockedIds: [...DEFAULT_UNLOCKED_GUARDIAN_IDS],
  // Currently equipped guardian id, or "none".
  selectedId: GUARDIAN_NONE_ID,
  // True once we've tried to load persisted state (from the DB, later).
  hydrated: false,
  purchasingId: null,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GUARDIAN_STATE:
      return {
        ...state,
        unlockedIds: action.payload.unlockedIds,
        selectedId: action.payload.selectedId,
        hydrated: true,
      };
    case SET_GUARDIAN_HYDRATED:
      return {...state, hydrated: !!action.payload};
    case UNLOCK_GUARDIAN:
      return state.unlockedIds.includes(action.payload)
        ? state
        : {...state, unlockedIds: [...state.unlockedIds, action.payload]};
    case SET_SELECTED_GUARDIAN:
      return {...state, selectedId: action.payload};
    case SET_GUARDIAN_PURCHASING:
      return {...state, purchasingId: action.payload};
    case SET_GUARDIAN_ERROR:
      return {...state, error: action.payload};
    case RESET_GUARDIANS:
      return {
        ...initialState,
        unlockedIds: [...DEFAULT_UNLOCKED_GUARDIAN_IDS],
      };
    default:
      return state;
  }
};

export default reducer;
